import React from 'react'
import NavBar from '../components/Home/NavBar';
import DeclaracionJurada from '../components/Forms/DeclaracionJurada/DeclaracionJurada';



const Ddjj = () => {
  return (
    <div>
        <NavBar />
        <DeclaracionJurada />
    </div>
  )
}

export default Ddjj